<template>
    <div class="showcase-option">
        <component class="showcase-option__icon" :is="icons[icon]" :text="valueText"></component>
        <span class="showcase-option__description">
            {{ name }}
        </span>
        <!--<span class="showcase-option__value" v-if="type !== 'bool'">-->
            <!--{{ _value }}-->
        <!--</span>-->
    </div>
</template>

<script type="text/babel">
import icons from '../../assets/icons';

export default {
  props: {
    _id: {
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    unit: {
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    show: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      icons,
    };
  },
  computed: {
    valueText() {
      if (this.type === 'bool') return null;
      const includeUnit = !['km/h'].includes(this.unit);
      return (includeUnit) ? `${this.value} ${this.unit}` : this.value;
    },
    icon() {
      return 'speed';
    },
  },
};
</script>

<style lang="scss" scoped>
    .showcase-option {
        display: block;
        &__icon {
            width: 100%;
        }
        &__description {
            display: block;
            font-size: .95em;
        }
        &__value {
            display: block;
            font-size: 2em;
            background: linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 800;
            text-align: center;
        }
    }
</style>
